var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97146 4.23183V2.13933C8.97146 1.80183 8.56646 1.63683 8.33396 1.87683L5.48396 4.71933C5.33396 4.86933 5.33396 5.10183 5.48396 5.25183L8.32646 8.09433C8.56646 8.32683 8.97146 8.16183 8.97146 7.82433V5.73183C11.769 5.73183 13.9815 8.29683 13.3665 11.1993C13.014 12.9018 11.634 14.2743 9.93896 14.6268C7.26146 15.1893 4.87646 13.3518 4.51646 10.8693C4.46396 10.5093 4.14896 10.2318 3.78146 10.2318C3.33146 10.2318 2.97146 10.6293 3.03146 11.0793C3.49646 14.3718 6.63146 16.8093 10.179 16.1193C12.519 15.6618 14.4015 13.7793 14.859 11.4393C15.6015 7.59183 12.6765 4.23183 8.97146 4.23183Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.fdb6c91fb1296b3289be87a068a5e8a7.svg";
export { ForwardRef as ReactComponent };